import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import DateRangeFilter from "../../../../components/FilterField/DateRangeFilter";
import DateRangePicker from "react-bootstrap-daterangepicker";
import * as moment from "moment";

class NetworkDeviceContentActivityDeleteLogs extends Component {

    state = {
        valueApply: "",
        submitValue: null
    }

    handleApply = (event, picker) => {
        const start = moment(picker.startDate).format("YYYY-MM-DD");
        const end = moment(picker.endDate).format("YYYY-MM-DD");
        this.setState({
            valueApply: `${start} - ${end}`,
            submitValue: `${start}/${end}`
        });
    };

    clearFilter = (e) => {
        e.stopPropagation();
        this.setState({
            valueApply: '',
            submitValue: null
        })
    }

    submit = () => {
        this.props.onSubmit(this.state.submitValue);
    }

    render() {
        const {t} = this.props;
        const { valueApply } = this.state;
        return (
            <React.Fragment>
                <p><b>{t('delete-logs-instruction')}</b></p>
                <div className="input-group">
                    <div className="input-group-prepend">
                        <DateRangePicker onApply={this.handleApply}>
                            <button className="btn btn-outline-secondary" type="button">
                                <i className="fas fa-calendar"/>
                            </button>
                        </DateRangePicker>
                    </div>
                    <input type="text" className="form-control" placeholder="" value={valueApply} readOnly />
                    <div className="input-group-append">
                        <button className="btn btn-outline-danger" onClick={(e) => this.clearFilter(e)} type="button">
                            <i className="fas fa-times"/>
                        </button>
                    </div>
                </div>

                <div className="mt-3 form-group float-right">
                    <button className={"btn btn-danger mx-1" } onClick={this.submit} disabled={this.state.submitValue === null}>
                        <i className="fas fa-trash"> </i> {t('delete-logs')}
                    </button>
                    <button type="button" className={"btn btn-secondary mx-1"} onClick={this.handleCloseModal}>
                        <i className="fas fa-times"> </i> {t('close')}
                    </button>

                </div>

            </React.Fragment>
        )
    }

}
export default withNamespaces()(NetworkDeviceContentActivityDeleteLogs);
